<template>
  <div>
    <div class="d-flex mb-1">
      <div>{{ dataItem.usage | toNumber }} mb</div>
      <div class="mx-1">
        /
      </div>
      <div>{{ dataItem.limit | toNumber }} mb</div>
    </div>
    <b-progress
      :value="dataItem.usage"
      :max="dataItem.limit"
      variant="warning"
      show-progress
      class="mb-1 bg-light-warning"
      style="height: 20px"
    />
  </div>
</template>
<script>
import {
  BProgress,
} from 'bootstrap-vue'

export default {
  name: 'DiskUsage',
  components: {
    BProgress,
  },
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
  },
}
</script>
